import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=222aa726&scoped=true"
import script from "../js/index.js?vue&type=script&lang=js&external"
export * from "../js/index.js?vue&type=script&lang=js&external"
import style0 from "./Index.vue?vue&type=style&index=0&id=222aa726&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "222aa726",
  null
  
)

export default component.exports